import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getEvents(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EVENTS,
		ModulesConfigMap[ModulesMap.EVENTS].GET_EVENTS,
		options
	)
}

function _getEvent(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EVENTS,
		ModulesConfigMap[ModulesMap.EVENTS].GET_EVENT,
		options
	)
}

function _getEventPreview(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EVENTS,
		ModulesConfigMap[ModulesMap.EVENTS].GET_EVENT_PREVIEW,
		options
	)
}

function _patchEvent(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EVENTS,
		ModulesConfigMap[ModulesMap.EVENTS].PATCH_EVENT,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.EVENTS].GET_EVENTS]: _getEvents,

	[ModulesConfigMap[ModulesMap.EVENTS].GET_EVENT]: _getEvent,

	[ModulesConfigMap[ModulesMap.EVENTS].GET_EVENT_PREVIEW]: _getEventPreview,

	[ModulesConfigMap[ModulesMap.EVENTS].PATCH_EVENT]: _patchEvent,
}
